import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { FcChoiceDialogModule } from '@core/components/fc-choice-dialog/fc-choice-dialog.module';
import { FcChoiceDialogService } from '@core/components/fc-choice-dialog/fc-choice-dialog.service';
import { DirectivesModule } from '@core/directives/directives.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ImportsService } from 'app/main/settings/imports/services/imports.service';
import { EquipmentsTypesApi } from 'app/main/settings/registers/equipments-types/services/api/equipments-types-api.service';
import { EquipmentsService } from '../services/equipments-resolver.service';
import { DialogEquipmentComponent } from './dialog-equipments.component';
import { DialogEquipmentService } from './dialog-equipments.service';
import { TabAttachmentsModule } from './tabs/attachments/tab-attachments.module';
import { TabCustomFieldsModule } from './tabs/custom-fields/tab-custom-fields.module';
import { TabEquipmentsModule } from './tabs/equipments/tab-equipments.module';
import { TabEquipmentHistoricModule } from './tabs/historic/tab-equipment-historic.module';
import { TabMaintenancesModule } from './tabs/maintenances/tab-maintenances.module';
import { TabNewGeneralModule } from './tabs/new-general/tab-new-general.module';
import { TabQrCodeModule } from './tabs/qrcode/tab-qr-code.module';

@NgModule({
  entryComponents: [
    DialogEquipmentComponent
  ],
  declarations: [
    DialogEquipmentComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    MatInputModule,
    TabNewGeneralModule,
    TabEquipmentsModule,
    TabCustomFieldsModule,
    TabAttachmentsModule,
    TabEquipmentHistoricModule,
    TabMaintenancesModule,
    TabQrCodeModule,
    DisclaimerModule,
    MatDialogModule,
    FcChoiceDialogModule,
    DirectivesModule
  ],
  exports: [
    DialogEquipmentComponent
  ],
  providers: [
    ImportsService,
    EquipmentsTypesApi,
    EquipmentsService,
    DialogEquipmentService,
    FcChoiceDialogService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogEquipmentsModule { }
